var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',_vm._g({directives:[{name:"body",rawName:"v-body"},{name:"click-outside",rawName:"v-click-outside",value:(function () { return (this$1.show = false); }),expression:"() => (this.show = false)"}],staticClass:"flex-column menu",on:{"click":_vm.closeMenu}},_vm.$listeners),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }